import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'orderStatus'
})
export class OrderStatusPipe implements PipeTransform {

  constructor(public readonly translate: TranslateService) {
  }

  transform(value: unknown, ...args: unknown[]): unknown {
    switch (value) {
      case 'accepted':
        return this.translate.instant('order-display-table-status-accepted');
      case 'inpreparation':
        return this.translate.instant('order-display-table-status-inpreparation');;
      case 'inprocess':
        return this.translate.instant('order-display-table-status-inprocess');;
      case 'finished':
        return this.translate.instant('order-display-table-status-finished');;
      default:
        return this.translate.instant('order-display-table-status-error');;
    }
  }

}
